import {
  animate,
  animateChild,
  group,
  query,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

const time = '0.2s ease-in-out';

const titleStateScrolledHidden = {
  padding: '1.2rem 2rem',
};
export const titleAnimation = trigger('titleAnimation', [
  state(
    'visible',
    style({
      padding: '2rem 2rem',
    }),
  ),
  state('scrolled', style(titleStateScrolledHidden)),
  state('hidden', style(titleStateScrolledHidden)),
  transition('* <=> *', animate(time)),
]);

const filtersStateScrolledHidden = {
  padding: '0.8rem 2rem',
  boxShadow: 'var(--shadow-interaction-200)',
  borderBottom: '1px solid var(--color-border-default)',
};
export const filtersAnimation = trigger('filtersAnimation', [
  state(
    'visible',
    style({
      padding: '1.2rem 2rem',
    }),
  ),
  state('scrolled', style(filtersStateScrolledHidden)),
  state('hidden', style(filtersStateScrolledHidden)),
  transition('* <=> *', animate(time)),
]);

const toolbarStateVisibleScrolled = {
  maxHeight: '500px',
  opacity: 1,
};
export const toolbarCollapse = trigger('toolbarCollapse', [
  state(
    'hidden',
    style({
      maxHeight: 0,
      opacity: 0,
    }),
  ),
  state('visible', style(toolbarStateVisibleScrolled)),
  state('scrolled', style(toolbarStateVisibleScrolled)),
  transition('void <=> hidden', group([query('@*', animateChild()), animate(time)])),
  transition('* <=> hidden', group([query('@*', animateChild()), animate(time)])),
  transition('hidden => scrolled', group([query('@*', animateChild()), animate(time)])),
  transition('scrolled => visible', group([group([query('@*', animateChild()), animate(time)])])),
]);
